<form [formGroup]="formName">
  <label>
    {{ field.label }}
    <input
      [formControlName]="field.filterKey"
      [name]="field.label"
      [type]="field.type"
      [value]="field.value"
    />
  </label>
</form>
